import React from 'react';
import { StreamChatMessagesContext } from '../context';

export const useChat = () => {
  const context = React.useContext(StreamChatMessagesContext);

  if (context === undefined) {
    throw new Error('useChat must be used within a StreamChatMessagesProvider');
  }

  return context;
};
